/**
 * Static constants used across the Landing page (logos, gallery, languages).
 * Brand-specific data lives here so it can be cached and tree-shaken
 * separately from the giant COPY bank.
 */
import { HardHat, Hammer, Sparkles, ClipboardCheck, Building, Zap } from "lucide-react";

export const LOGO_URL = "/logos/agentelead-pro-dark-bg.png";
export const LOGO_URL_LIGHT = "/logos/agentelead-pro-light-bg.png";

// Brand Logo CDN — simpleicons serves flat mono SVGs.
export const BRAND = (slug, color = "0F172A") => `https://cdn.simpleicons.org/${slug}/${color}`;

const LINKEDIN_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_lead-discovery-hub-3/artifacts/nhkdl6q2_Linkedin%20Logo.png";

export const INTEGRATION_LOGOS = [
  { name: "Google Maps",    slug: "googlemaps",   color: "4285F4" },
  { name: "Instagram",      slug: "instagram",    color: "E4405F" },
  { name: "LinkedIn Sales", slug: "linkedin",     color: "0A66C2", customSrc: LINKEDIN_LOGO_URL },
  { name: "YouTube",        slug: "youtube",      color: "FF0000" },
  { name: "Yelp",           slug: "yelp",         color: "D32323" },
  { name: "Reddit",         slug: "reddit",       color: "FF4500" },
];

// Business-type stock photography (Pexels — stable hot-links).
export const BUSINESS_GALLERY = [
  { key: "roofing",  img: "https://images.pexels.com/photos/209235/pexels-photo-209235.jpeg?auto=compress&cs=tinysrgb&w=800",                             icon: HardHat,        ptName: "Roofing",          enName: "Roofing",            esName: "Techos" },
  { key: "hvac",     img: "https://images.pexels.com/photos/4108715/pexels-photo-4108715.jpeg?auto=compress&cs=tinysrgb&w=800",                          icon: Hammer,         ptName: "HVAC",             enName: "HVAC",               esName: "HVAC" },
  { key: "solar",    img: "https://images.pexels.com/photos/356036/pexels-photo-356036.jpeg?auto=compress&cs=tinysrgb&w=800",                            icon: Sparkles,       ptName: "Solar",            enName: "Solar",              esName: "Solar" },
  { key: "plumbing", img: "https://images.pexels.com/photos/8486936/pexels-photo-8486936.jpeg?auto=compress&cs=tinysrgb&w=800",                          icon: ClipboardCheck, ptName: "Encanamento",      enName: "Plumbing",           esName: "Plomería" },
  { key: "gc",       img: "https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?auto=compress&cs=tinysrgb&w=800", icon: Building,       ptName: "Construção Geral", enName: "General Contractor", esName: "Contratista General" },
  { key: "elect",    img: "https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg?auto=compress&cs=tinysrgb&w=800",                            icon: Zap,            ptName: "Elétrica",         enName: "Electrical",         esName: "Eléctricos" },
];

export const AVATARS = [
  "https://images.unsplash.com/photo-1576558656222-ba66febe3dec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzc3NTY3MzU0fDA&ixlib=rb-4.1.0&q=75",
  "https://images.unsplash.com/photo-1655249481446-25d575f1c054?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzc3NTY3MzU0fDA&ixlib=rb-4.1.0&q=75",
  "https://images.pexels.com/photos/14589344/pexels-photo-14589344.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const LANGS = [
  { code: "en", flag: "EN" },
  { code: "pt", flag: "PT" },
  { code: "es", flag: "ES" },
];

// Framer-motion entrance preset — staggered fade-up used by hero, sections, etc.
export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.55, delay: i * 0.06, ease: [0.21, 0.47, 0.32, 0.98] },
  }),
};
